const userAgent = window.navigator.userAgent.toLowerCase();

export const browsers = {
  isWindows: () => navigator.platform.indexOf('Win') > -1,
  isChrome: () => /chrome|chromium|crios/.test(userAgent) && !/edg|opr\//.test(userAgent),
  isFirefox: () => /firefox/.test(userAgent),
  isSafari: () => /safari/.test(userAgent) && !/chrome|chromium|crios/.test(userAgent),
  isMobile: () => /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent),
  isIpad: () => /ipad/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}; 